import { FlagProvider as UnleashFlagProvider } from '@unleash/proxy-client-react';

const flagConfig = {
  url: import.meta.env.VITE_UNLEASH_PROXY_URL, // Your front-end API URL or the Unleash proxy's URL (https://<proxy-url>/proxy)
  clientKey: import.meta.env.VITE_UNLEASH_CLIENT_KEY, // A client-side API token OR one of your proxy's designated client keys (previously known as proxy secrets)
  environment: import.meta.env.MODE,
  refreshInterval: 300, // How often (in seconds) the client should poll the proxy for updates
  appName: 'greener-projects-fe', // The name of your application. It's only used for identifying your application
};

export const UnleashProvider = ({ children }) => {
  return <UnleashFlagProvider config={flagConfig}>{children}</UnleashFlagProvider>;
};
